export const PLATFORM = {
  DDE: 'dde',
  DGE: 'dge'
} as const

export const DGE_AUTH_METHOD = {
  LEGACY: 'legacy',
  KEYCLOAK: 'keycloak'
} as const

// The Streams (DGE) platform is not migrating to srarena.io: its backend stays on
// imgarena and streaming customers are served by ALC instead. srarena builds set the
// flag to false so the platform is hidden rather than failing on every request.
export const STREAMS_PLATFORM_ENABLED = import.meta.env.VITE_ENABLE_STREAMS_PLATFORM !== 'false'
